interface SplitsTextRow {
    name: string;
    /** Type text as the row shows it; null when no type is set. */
    type: string | null;
    verified: boolean;
    note: string;
    /** Sheets only: why the row makes no document. */
    leftOutReason?: string;
}

export interface SplitsText {
    fileName: string;
    /** "17 pages" / "3 sheets"; omitted while unknown. */
    sizeText: string | null;
    url: string;
    rows: SplitsTextRow[];
    leftOutText: string;
    gapsText: string;
    /** Heading for `gapsText`; defaults to the page wording. */
    gapsLabel?: string;
    fileNote: string;
    verifiedCount: number;
    unsavedCount: number;
}

/** The split on screen as Markdown that non-technical readers can follow. */
export function splitsAsText(input: SplitsText): string {
    const lines = [
        `**${input.fileName}**${input.sizeText ? ` (${input.sizeText})` : ''}`,
        `Link: ${input.url}`,
        '',
    ];
    for (const row of input.rows) {
        const status =
            row.leftOutReason !== undefined
                ? `left out${row.leftOutReason ? ` (${row.leftOutReason})` : ''}`
                : `${row.type ?? 'No type yet'}${row.verified ? ' ✓ Verified' : ', not verified yet'}`;
        lines.push(`- ${row.name}: ${status}`);
        if (row.note.trim() !== '') lines.push(`  Note: ${row.note.trim()}`);
    }
    const extra = [
        input.leftOutText && `Left out on purpose: ${input.leftOutText}`,
        input.gapsText &&
            `${input.gapsLabel ?? 'Not in any document yet'}: ${input.gapsText}`,
        input.fileNote.trim() && `File note: ${input.fileNote.trim()}`,
    ].filter(Boolean);
    if (extra.length > 0) lines.push('', ...(extra as string[]));
    const summary = [
        `${input.verifiedCount} of ${input.rows.length} verified`,
        input.unsavedCount > 0
            ? `${input.unsavedCount} unsaved change${input.unsavedCount === 1 ? '' : 's'}`
            : '',
    ].filter(Boolean);
    lines.push(`(${summary.join(' · ')})`);
    return lines.join('\n');
}
